import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "topbar"
};
const _hoisted_2 = {
  class: "header-filters",
  gap: 28
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "Search Funnel", -1);
const _hoisted_4 = {
  class: "toolbar"
};
const _hoisted_5 = {
  class: "navigation-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_search_funnel_filters = _resolveComponent("search-funnel-filters");
  const _component_app_button_radio_group = _resolveComponent("app-button-radio-group");
  const _component_currency_filter = _resolveComponent("currency-filter");
  const _component_navigation_tabs = _resolveComponent("navigation-tabs");
  const _component_period_controllers = _resolveComponent("period-controllers");
  const _component_period_table = _resolveComponent("period-table");
  const _component_opportunities_period_table = _resolveComponent("opportunities-period-table");
  const _component_product_table = _resolveComponent("product-table");
  const _component_flex_column = _resolveComponent("flex-column");
  const _component_omny_ui_layout = _resolveComponent("omny-ui-layout");
  return _openBlock(), _createBlock(_component_omny_ui_layout, {
    "content-padding": "0",
    class: "search-funnel"
  }, {
    topbar: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_search_funnel_filters)]), _createVNode(_component_app_button_radio_group, {
      class: "keyword-type-filter",
      options: $options.targetingTypeOptions,
      modelValue: $options.selectedTargetingType,
      valueField: "key",
      "onUpdate:modelValue": $options.onTargetingTypeChange
    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_currency_filter, {
      currencies: _ctx.currencies,
      "only-mode": "",
      onApply: $options.handleApplyForCurrencyChange
    }, null, 8, ["currencies", "onApply"])])])]),
    "topbar-sub": _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_navigation_tabs, {
      tabs: _ctx.tabs,
      modelValue: $options.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.tab = $event),
      class: "search-funnel-tabs"
    }, null, 8, ["tabs", "modelValue"]), _withDirectives(_createVNode(_component_period_controllers, {
      period: $options.period,
      "onUpdate:period": _cache[1] || (_cache[1] = $event => $options.period = $event),
      periodCategory: $options.periodCategory,
      "onUpdate:periodCategory": _cache[2] || (_cache[2] = $event => $options.periodCategory = $event),
      periodOptions: $options.periodOptions,
      periodSelectorOptions: _ctx.periodSelectorOptions
    }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"]), [[_vShow, _ctx.floatingTableState === $data.FLOATING_COMPOUND_TABLE_STATES.FULL_SIZE]])])]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: _normalizeClass(["search-funnel-contents", [_ctx.floatingTableState]])
    }, [_createVNode(_component_flex_column, {
      gap: 24,
      classes: "all-wrapper"
    }, {
      default: _withCtx(() => [_ctx.currentTabValue === 'performance' ? (_openBlock(), _createBlock(_component_period_table, {
        key: 0,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[5] || (_cache[5] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[3] || (_cache[3] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[4] || (_cache[4] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _ctx.currentTabValue === 'opportunities' ? (_openBlock(), _createBlock(_component_opportunities_period_table, {
        key: 1,
        loading: $data.periodTableLoading,
        onSetDateRange: $options.handleSetPeriodTable,
        onRefresh: _cache[8] || (_cache[8] = $event => this.refreshMediator(['PERIOD_TABLE']))
      }, {
        "period-selector": _withCtx(() => [_createVNode(_component_period_controllers, {
          period: $options.period,
          "onUpdate:period": _cache[6] || (_cache[6] = $event => $options.period = $event),
          periodCategory: $options.periodCategory,
          "onUpdate:periodCategory": _cache[7] || (_cache[7] = $event => $options.periodCategory = $event),
          periodOptions: $options.periodOptions,
          periodSelectorOptions: _ctx.periodSelectorOptions
        }, null, 8, ["period", "periodCategory", "periodOptions", "periodSelectorOptions"])]),
        _: 1
      }, 8, ["loading", "onSetDateRange"])) : _createCommentVNode("", true), _createVNode(_component_product_table, {
        loading: $data.productTableLoading,
        onRefreshOtherKpis: _cache[9] || (_cache[9] = $event => this.refreshMediator(['PERIOD_TABLE'])),
        onRefresh: _cache[10] || (_cache[10] = $event => $options.refreshProductTable()),
        onHandleSort: $options.handleProductTableSort,
        onChangeDate: $options.handleDateChange,
        onRestoreEvolutionTable: $options.restoreEvolutionTable,
        secondaryFilterInitializers: $data.secondaryFilterInitializers
      }, null, 8, ["loading", "onHandleSort", "onChangeDate", "onRestoreEvolutionTable", "secondaryFilterInitializers"])]),
      _: 1
    })], 2)]),
    _: 1
  });
}